import React from 'react';
import moment from 'moment';
import { Box } from '@material-ui/core';

const AssignedCompletedCell = ({
  task
}: any) => (
  <Box>
    {
        task.completedDatetime ? (
          `Completed ${moment(task.completedDatetime).fromNow()}`
        ) : `Assigned ${moment(task.assignedDatetime).fromNow()}`
      }
  </Box>
);

export default AssignedCompletedCell;
